<template>
  <div class="app-container blacklist">
    <div class="blacklist-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="blacklist-filter-value" v-model.trim="search.unionId" @keyup.enter.native="searchChange" placeholder="员工号" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="blacklist-filter-value" v-model.trim="search.realname" @keyup.enter.native="searchChange" placeholder="Birth Name或Full Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="blacklist-filter-value" v-model.trim="search.organizationalUnitName" @keyup.enter.native="searchChange" placeholder="Organizational Unit Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="blacklist-filter-value" placeholder="状态" v-model="search.status" clearable size="small">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div>
            <el-button class="blacklist-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="blacklist-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="blacklist-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="list"
                 :page="page"
                 :table-loading="listLoading"
                 @current-change="handleCurrentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot-scope="scope" slot="phoneNumber">
          <sensitive-data type="phoneNumber" :rawData="scope.row.phoneNumber" :unionId="scope.row.unionId" />
        </template>

        <template slot-scope="scope" slot="projects">
          <div
            :class="{'blacklist-project': true, 'blacklist-project-deleted': item.projectIsDeleted }"
            v-for="(item, index) in scope.row.projects"
            :key="index"
            @click="handleViewProject(item)">
            {{ item.projectName }}
          </div>
        </template>

        <template slot="menuLeft">
          <el-button
            v-if="permissions.blacklist_export"
            class="filter-item"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>
        </template>

        <template slot-scope="scope" slot="menu">
          <el-row>
            <el-button size="mini"
              type="text"
              :disabled="scope.row.status === 2"
              v-if="permissions.blacklist_unfreeze"
              @click="handleClickManuallyUnfreeze(scope.row)">解除冻结
            </el-button>
          </el-row>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      title="解除冻结"
      :visible.sync="manuallyUnfreezeDialogVisible"
      :close-on-click-modal="false"
      @closed="handleManuallyUnfreezeDialogClosed"
      class="manually-unfreeze-dialog">
       <template>
          <el-row class="activity-detail-item">
            <el-col :span="3" >员工号:</el-col>
            <el-col :span="16">{{ memberUnionId }}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="3" >Birth Name:</el-col>
            <el-col :span="16">{{ memberRealname }}</el-col>
          </el-row><br />
          <el-row>选择需解除冻结的报名未签到子项目</el-row>
          <avue-crud ref="projectCrud"
                  :option="blacklistProjectTableOption"
                  :data="blacklistProjectList"
                  @selection-change="handleProjectSelectionChange">

        </avue-crud>
        <el-row>解除原因:</el-row><br />
        <el-input type="textarea" :rows="3" v-model="unfreezeReason" :maxlength="500"></el-input>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="manuallyUnfreezeDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmManuallyUnfreeze">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Api from '@/api/app/activity';
  import { exporting } from '@/util/exportUtil'
  import {blacklistTableOption as tableOption, blackStatusOptions as statusOptions, blacklistProjectTableOption} from '@/const/crud/app/activity'
  import {mapGetters} from "vuex";
  import SensitiveData from '@/components/sensitive-data';

  export default {
    components: {
      SensitiveData,
    },
    data() {
      return {
        search: {
          current: 1,
          size: 10,
          sortField: '',
          sortPolicy: '',
          unionId: '',
          realname: '',
          organizationalUnitName: '',
          status: undefined,
        },
        exportLoading: false,
        exportName: '导出',
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableOption,
        statusOptions,
        listLoading: false,
        form: {},
        list: [],
        blacklistProjectTableOption,
        blacklistProjectList: [],
        manuallyUnfreezeDialogVisible: false,
        memberUnionId: '',
        unfreezeReason: '',
        unfreezeProjects: [],
      };
    },
    activated () {
      this.initPage()
      this.getList()
    },
    async created() {
      await this.initPage()
      await this.getList()
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    methods: {
      getList() {
        let params = {
          current: this.search.current,
          size: this.search.size,
        }
        if (this.search.unionId != '' && this.search.unionId.trim() != '')
          params.unionId = this.search.unionId
        if (this.search.realname != '' && this.search.realname.trim() != '')
          params.realname = this.search.realname
        if (this.search.organizationalUnitName != '' && this.search.organizationalUnitName.trim() != '')
          params.organizationalUnitName = this.search.organizationalUnitName
        if (this.search.status)
          params.status = this.search.status;
        
        if (this.search.sortField != '' && this.search.sortField.trim() != '')
          params.sortField = this.search.sortField
        else {
          params.sortField = 'id'
        }
        if (this.search.sortPolicy != '' && this.search.sortPolicy.trim() != '')
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = 'desc'
        }
        this.listLoading = true
        Api.fetchActivityBlacklist(params).then(response => {
          this.list = response.data.data.records
          this.page.total = response.data.data.total
          this.listLoading = false
        });
        this.listLoading = false
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.unionId = ''
        this.search.realname = ''
        this.search.organizationalUnitName = ''
        this.search.status = undefined
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleRefreshChange() {
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getList()
      },
      handleSortChange(val) {
        if (val.prop == 'startTime') {
          this.search.sortField = 'start_time'
        } else if (val.prop == 'endTime') {
          this.search.sortField = 'end_time'
        } else if (val.prop == 'status') {
          this.search.sortField = 'status'
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = 'asc'
        } else if (val.order == 'descending') {
          this.search.sortPolicy = 'desc'
        } else {
          this.search.sortField = 'id'
          this.search.sortPolicy = 'desc'
        }
        this.getList()
      },
      handleExport() {
        let params = {}

        if (this.search.unionId != '' && this.search.unionId.trim() != '')
          params.unionId = this.search.unionId
        if (this.search.realname != '' && this.search.realname.trim() != '')
          params.realname = this.search.realname
        if (this.search.organizationalUnitName != '' && this.search.organizationalUnitName.trim() != '')
          params.organizationalUnitName = this.search.organizationalUnitName

        if (this.search.sortField != '' && this.search.sortField.trim() != '')
          params.sortField = this.search.sortField
        else {
          params.sortField = 'id'
        }
        if (this.search.sortPolicy != '' && this.search.sortPolicy.trim() != '')
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = 'desc'
        }

        Api.exportActivityBlacklist(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = '导出中...'
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '数据导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = '导出'
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
          })
        }
      },
      handleViewProject(row) {
        if (row.projectIsDeleted) {
          return this.$message.warning('该子项目已被删除')
        }
        const route = this.$router.resolve({
          path: `/app/activity/detail/${row.activityId}`,
          query: {
            showTab: 'activityProject',
          },
        });
        window.open(route.href, '_blank');
      },
      handleClickManuallyUnfreeze(row) {
        this.manuallyUnfreezeDialogVisible = true;
        this.blacklistProjectList = row.projects;
        this.memberUnionId = row.unionId;
        this.memberRealname = row.realname;
      },
      handleProjectSelectionChange(selection) {
        this.unfreezeProjects = selection
      },
      confirmManuallyUnfreeze() {
        if (this.unfreezeProjects.length === 0) {
          return this.$message.error('请选择需解除冻结的报名未签到子项目')
        }
        if (!this.unfreezeReason || !this.unfreezeReason.trim()) {
          return this.$message.error('请填写解除原因')
        }

        const params = {
          unionId: this.memberUnionId,
          blacklistId: this.unfreezeProjects[0].blacklistId,
          projectIds: this.unfreezeProjects.map(item => item.projectId),
          reason: this.unfreezeReason,
        }
        Api.manuallyUnfreezeActivityBlacklist(params).then(response => {
          if (response.status === 200) {
            if (this.blacklistProjectList.length - this.unfreezeProjects.length >= 3) {
              this.$message.warning('目前仍有不少于3个报名未签到子项目，如需解除冻结该用户，请再次操作。')
            } else {
              this.$message.success('成功解除冻结')
            }
            this.manuallyUnfreezeDialogVisible = false;
            this.getList()
          }
        });
      },
      handleManuallyUnfreezeDialogClosed() {
        this.blacklistProjectList = [];
        this.memberUnionId = '';
        this.memberRealname = '';
        this.unfreezeReason = '';
      }
    }
  };
</script>

<style lang="scss" scoped>
.blacklist {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-empty {
      display: block;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-location-value {
      width: calc(100% - 12px) !important;
      input {
        border: none !important;
      }
    }
    &-date {
      width: 96%!important;
    }
    &-search {
      float: right;
      margin-right: 10px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }

  &-project {
    text-align: left;
    cursor: pointer;
    color: #409EFF;
    &-deleted {
      color: #c0c4cc;
    }
  }
}
.manually-unfreeze-dialog {
  /deep/ .avue-crud__menu {
    display: none;
  }
  /deep/ .el-card__body {
    padding-top: 0;
    padding-bottom: 10px;
  }
}
</style>
